import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCManageParentalCommunityInvolvementInCYRCs = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Parental / community involvement in CYRCs" />
    </Box>
  );
};
